"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFleetVehicleType = exports.formatPassenger = exports.formatManualInvoiceNumber = exports.mapTransfusionBookingRequestStatusToLabel = exports.formatTimeWithTimeReference = exports.formatAge = exports.formatBundleName = exports.formatBundleType = exports.formatBundleSectorization = exports.formatBundleTimeRange = exports.formatBundleTimeSlot = exports.formatPoolingDiscount = exports.normalizePoolingDiscountRate = void 0;
exports.formatTimeSlot = formatTimeSlot;
exports.parseEuroToCents = parseEuroToCents;
exports.parseCents = parseCents;
exports.formatCents = formatCents;
exports.formatPercent = formatPercent;
exports.convertMetersToKm = convertMetersToKm;
exports.formatTime = formatTime;
exports.formatTripTime = formatTripTime;
exports.formatNir = formatNir;
exports.formatVehicle = formatVehicle;
exports.formatTransfusionVehicle = formatTransfusionVehicle;
exports.formatDirection = formatDirection;
exports.formatDistance = formatDistance;
exports.formatDuration = formatDuration;
exports.formatInvoiceNumber = formatInvoiceNumber;
exports.formatPassengerCancelationType = formatPassengerCancelationType;
exports.formatPatientName = formatPatientName;
var currency_js_1 = __importDefault(require("currency.js"));
var moment_1 = __importDefault(require("@ambler/moment"));
var __1 = require("..");
var utils_1 = require("../utils");
function formatTimeSlot(timeSlot) {
    switch (timeSlot) {
        case 'NIGHT':
            return 'Nuit';
        case 'SATURDAY':
        case 'SUNDAY':
        case 'HOLIDAY':
            return 'Week-end & j. fériés';
        case 'WEEKDAY':
            return 'Aucune';
    }
    (0, __1.assertUnreachable)(timeSlot);
}
var normalizePoolingDiscountRate = function (patientCount) {
    switch (patientCount) {
        case 2:
            return 'POOLING_2_DISCOUNT';
        case 3:
            return 'POOLING_3_DISCOUNT';
        default:
            return 'NONE';
    }
};
exports.normalizePoolingDiscountRate = normalizePoolingDiscountRate;
var formatPoolingDiscount = function (value) {
    switch (value) {
        case 'POOLING_2_DISCOUNT':
            return 'Abattement 2 passagers';
        case 'POOLING_3_DISCOUNT':
            return 'Abattement 3 passagers';
        case 'NONE':
            return 'Aucun';
    }
    (0, __1.assertUnreachable)(value);
};
exports.formatPoolingDiscount = formatPoolingDiscount;
function parseEuroToCents(rawEuro) {
    return (0, currency_js_1.default)(rawEuro.replace(',', '.')).intValue;
}
// 2270 => "22.70"
function parseCents(cents) {
    return (0, currency_js_1.default)(cents / 100.0, {
        precision: 2,
        decimal: '.',
        pattern: '#',
    }).format(true);
}
// 2270 => "22,70 €"
function formatCents(cents, round) {
    if (round === void 0) { round = false; }
    return (0, currency_js_1.default)(round ? Math.round(cents / 100.0) : cents / 100.0, {
        precision: round ? 0 : 2,
        symbol: '€',
        // * Insecable white-space
        separator: ' ',
        decimal: ',',
        pattern: '# !',
        negativePattern: '-# !',
    }).format(true);
}
function formatPercent(rate, decimals, options) {
    var result = "".concat((rate * 100).toFixed(decimals), "%").replace(/\./, ',');
    if (options === null || options === void 0 ? void 0 : options.trimTrailingZeros) {
        return result.replace(',00', '');
    }
    return result;
}
function convertMetersToKm(meters) {
    return Math.ceil(meters / 1000);
}
var formatBundleTimeSlot = function (timeSlot) {
    switch (timeSlot) {
        case 'DEFAULT':
            return 'Jour';
        case 'NIGHT':
            return 'Nuit';
        case 'SUNDAY_HOLIDAY':
            return 'Dimanches et jour fériés';
    }
    (0, __1.assertUnreachable)(timeSlot);
};
exports.formatBundleTimeSlot = formatBundleTimeSlot;
var shortWeekdayLabels = ['Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.', 'Dim.'];
var formatRangeHour = function (hour) { return "".concat(String(hour).padStart(2, '0'), ":00"); };
var formatTimeRangeHolidays = function (holidays) {
    switch (holidays) {
        case 'INCLUDED':
            return 'JF inclus';
        case 'ONLY':
            return 'JF uniq.';
        case 'EXCLUDED':
            return 'JF exclus';
    }
    (0, __1.assertUnreachable)(holidays);
};
// "Lun. 08:00 → 20:00 (JF inclus)", "Sam. 20:00 → Lun. 08:00 (JF exclus)",
// "Toute la semaine (JF uniq.)".
var formatBundleTimeRange = function (range) {
    var holidaysSuffix = " (".concat(formatTimeRangeHolidays(range.holidays), ")");
    if (range.startDay === range.endDay && range.startHour === range.endHour) {
        return "Toute la semaine".concat(holidaysSuffix);
    }
    var start = "".concat(shortWeekdayLabels[range.startDay - 1], " ").concat(formatRangeHour(range.startHour));
    var end = range.startDay === range.endDay && range.endHour > range.startHour
        ? formatRangeHour(range.endHour)
        : "".concat(shortWeekdayLabels[range.endDay - 1], " ").concat(formatRangeHour(range.endHour));
    return "".concat(start, " \u2192 ").concat(end).concat(holidaysSuffix);
};
exports.formatBundleTimeRange = formatBundleTimeRange;
/** Geographic criteria of a child bundle: departements first, then communes. */
var formatBundleSectorization = function (bundle) {
    var labels = __spreadArray(__spreadArray([], bundle.sectorGroups.map(function (group) { return (group.code ? "".concat(group.label, " (").concat(group.code, ")") : group.label); }), true), bundle.sectors.map(function (sector) { return sector.label; }), true);
    return labels.length ? labels.join(', ') : '–';
};
exports.formatBundleSectorization = formatBundleSectorization;
var formatBundleType = function (type) {
    switch (type) {
        case 'FIXED_TIME':
            return 'Fixe';
        case 'VARIABLE_TIME':
            return 'Variable';
    }
    (0, __1.assertUnreachable)(type);
};
exports.formatBundleType = formatBundleType;
var formatBundleName = function (bundle, mfu) {
    return [
        mfu === null || mfu === void 0 ? void 0 : mfu.name,
        bundle.mf.name && "".concat(!mfu ? bundle.mf.name : " (".concat(bundle.mf.name, ")"), " - "),
        "".concat(bundle.vehicle, " - "),
        "".concat((0, exports.formatBundleTimeSlot)(bundle.timeSlot), " "),
        "(".concat(bundle.payers.map(function (p) { return p.payer; }).join(', '), ")"),
    ]
        .filter(Boolean)
        .join('');
};
exports.formatBundleName = formatBundleName;
function formatTime(datetime, isReference, timezone) {
    if (isReference === void 0) { isReference = true; }
    return [!isReference && '~', (0, moment_1.default)(datetime).tzProtected(timezone).format('HH:mm')].filter(Boolean).join('');
}
function formatTripTime(status, timeReference, departureTime, arrivalTime, direction, humanize, timezone) {
    if (humanize === void 0) { humanize = false; }
    if (humanize && timeReference === 'UNKNOWN') {
        if (direction === 'OUTBOUND') {
            if ((0, utils_1.isIn)(['CREATED', 'DISPATCHING'], status)) {
                return ['Avant', "".concat(formatTime(departureTime, true, timezone))];
            }
            return [formatTime(departureTime, true, timezone), formatTime(arrivalTime, false, timezone)];
        }
        else if (direction === 'INBOUND') {
            return ['Heure', 'inconnue'];
        }
        return [];
    }
    return [
        [timeReference !== 'DEPARTURE' && '~', departureTime && formatTime(departureTime, true, timezone)]
            .filter(Boolean)
            .join(''),
        [timeReference !== 'ARRIVAL' && '~', arrivalTime && formatTime(arrivalTime, true, timezone)]
            .filter(Boolean)
            .join(''),
    ];
}
var birthdate_format = 'DD/MM/YYYY';
var formatAge = function (birthdate, now) {
    if (now === void 0) { now = (0, moment_1.default)(); }
    var years = now.diff((0, moment_1.default)(birthdate, birthdate_format), 'years');
    if (years > 0) {
        return "".concat(years, " ").concat(years > 1 ? 'ans' : 'an');
    }
    var months = now.diff((0, moment_1.default)(birthdate, birthdate_format), 'months');
    if (months > 0) {
        return "".concat(months, " mois");
    }
    var days = now.diff((0, moment_1.default)(birthdate, birthdate_format), 'days');
    return "".concat(days, " ").concat(days > 1 ? 'jours' : 'jour');
};
exports.formatAge = formatAge;
exports.formatAge.birthdate_format = birthdate_format;
var formatTimeWithTimeReference = function (_a) {
    var timeReference = _a.timeReference, departureTime = _a.departureTime, arrivalTime = _a.arrivalTime, timezone = _a.timezone, direction = _a.direction;
    if (timeReference === 'UNKNOWN' && direction === 'OUTBOUND' && departureTime) {
        return formatTime(departureTime, true, timezone);
    }
    if (timeReference === 'DEPARTURE' && departureTime) {
        return "D\u00E9part \u00E0 ".concat(formatTime(departureTime, true, timezone));
    }
    if (timeReference === 'ARRIVAL' && arrivalTime) {
        return "Arriv\u00E9e \u00E0 ".concat(formatTime(arrivalTime, true, timezone));
    }
    return 'Heure inconnue';
};
exports.formatTimeWithTimeReference = formatTimeWithTimeReference;
function formatNir(nirRaw) {
    if (!nirRaw) {
        return nirRaw;
    }
    var nir = nirRaw.replace(/ /g, '');
    if (nir.length === 15) {
        return [
            nir.substr(0, 1),
            nir.substr(1, 2),
            nir.substr(3, 2),
            nir.substr(5, 2),
            nir.substr(7, 3),
            nir.substr(10, 3),
            nir.substr(13, 2),
        ].join(' ');
    }
    return nirRaw;
}
function formatVehicle(vehicleType) {
    switch (vehicleType) {
        case 'AMBULANCE':
            return 'Ambulance';
        case 'VSL':
        case 'TAXI':
            return 'TAP';
        case 'TPS':
            return 'Transport pour personnel soignant';
        case 'TPMR':
            return 'TPMR';
        case 'BARIATRIC':
            return 'Bariatrique';
        case 'MEDICAL':
            return 'Ambulance médicalisée';
        case 'PARAMEDICAL':
            return 'Ambulance paramédicalisée';
    }
    (0, __1.assertUnreachable)(vehicleType);
}
function formatTransfusionVehicle(vehicle) {
    switch (vehicle) {
        case 'TAP':
            return 'TAP';
        case 'AMBULANCE':
            return 'Ambulance';
        case 'BARIATRIC':
            return 'Bariatrique';
        case 'TPMR':
            return 'TPMR';
        case 'PARAMEDICAL':
            return 'Ambulance paramédicalisée';
        case 'MEDICAL':
            return 'Ambulance médicalisée';
        case 'OTHER':
            return 'Autre';
    }
    (0, __1.assertUnreachable)(vehicle);
}
exports.mapTransfusionBookingRequestStatusToLabel = {
    CONFIRMED: 'Confirmé',
    CANCELED: 'Annulé',
    TO_CHECK: 'À vérifier',
    NORIDE: 'Non réalisé',
    WAITING: 'En attente',
    COMPLETED: 'Réalisé',
    SUPPORT: 'Incident',
    CHANGED: 'Modifié',
};
function formatDirection(direction) {
    switch (direction) {
        case 'OUTBOUND':
            return 'Aller';
        case 'INBOUND':
            return 'Retour';
    }
    (0, __1.assertUnreachable)(direction);
}
function formatDistance(distanceInMeter) {
    var km = convertMetersToKm(distanceInMeter);
    return "".concat(km, " km");
}
function formatDuration(durationInSeconds) {
    var duration = moment_1.default.duration(durationInSeconds, 's');
    var min = duration.get('m');
    var hour = duration.get('h');
    return [hour > 0 && "".concat(hour, " h"), min > 0 && "".concat(min, " min")].filter(Boolean).join(' ');
}
var formatManualInvoiceNumber = function (prefix, mtInvoiceReference) {
    return [prefix, mtInvoiceReference].filter(Boolean).join(' - ');
};
exports.formatManualInvoiceNumber = formatManualInvoiceNumber;
function formatInvoiceNumber(mtId, sequenceNumber) {
    return "".concat(mtId === null || mtId === void 0 ? void 0 : mtId.slice(-8), "-").concat(sequenceNumber === null || sequenceNumber === void 0 ? void 0 : sequenceNumber.toString().padStart(10, '0'));
}
function formatPassengerCancelationType(type) {
    switch (type) {
        case 'HPTL_PTNT_NOT_READY':
            return "Le patient n'est pas prêt à sortir";
        case 'HPTL_PTNT_LEFT':
            return 'Le patient part par un autre moyen';
        case 'HPTL_ORDER_ERROR':
            return 'Erreur dans la commande';
        case 'HPTL_APPOINTMENT_CANCELED':
            return 'Le rendez-vous ne peut plus avoir lieu';
        case 'HPTL_PTNT_CANCELED':
            return 'Transport annulé par le patient';
        case 'HPTL_PTNT_SCHEDULE_CHANGED':
            return 'Le patient change de rythme de séance';
        case 'HPTL_PTNT_SCHEDULE_ENDED':
            return 'La série du patient est terminée';
        case 'HPTL_TPTR_NOT_FOUND':
            return "Aucun transporteur n'a accepté la commande dans le temps imparti";
        case 'HPTL_OTHER':
            return 'Autre raison';
    }
    (0, __1.assertUnreachable)(type);
}
function formatGender(gender) {
    switch (gender) {
        case 'FEMALE':
            return 'Mme';
        case 'MALE':
            return 'M.';
        case 'UNKNOWN':
            return '';
    }
    (0, __1.assertUnreachable)(gender);
}
function formatAnonGender(gender) {
    switch (gender) {
        case 'FEMALE':
            return 'Femme';
        case 'MALE':
            return 'Homme';
        case 'UNKNOWN':
            return 'Patient';
    }
    (0, __1.assertUnreachable)(gender);
}
function formatPatientFirstname(value) {
    return value
        .trim()
        .replace(/\s+/g, ' ') // merge multiple spaces into one space
        .normalize('NFC') // merge decomposed accents (e + ´ → é)
        .toLocaleLowerCase('fr-FR') // reset casing, locale-aware
        .replace(/[^\s\-']+/g, function (part) {
        // particles stay lowercase
        if (['de', 'du', 'des', 'la'].includes(part))
            return part;
        return part.charAt(0).toLocaleUpperCase('fr-FR') + part.slice(1);
    });
}
function formatPatientLastname(value) {
    return value
        .trim()
        .replace(/\s+/g, ' ') // merge multiple spaces into one space
        .normalize('NFC') // merge decomposed accents (e + ´ → é)
        .toLocaleUpperCase('fr-FR');
}
/**
 * One formatter to rule them all
 *
 * ```text
 * DEFAULT: M. Jean-Luc DOE -- Homme / Femme / Patient
 * FULL: M. Jean-Luc DOE (Né DOA) -- Homme / Femme / Patient
 * SHORT: DOE Jean-Luc -- Homme (38 ans)
 * ```
 *
 * You must use it!
 */
function formatPatientName(patient, anonymous, kind) {
    var _a;
    if (anonymous === void 0) { anonymous = false; }
    var gender = (_a = patient.gender) !== null && _a !== void 0 ? _a : 'UNKNOWN';
    switch (kind) {
        case 'DEFAULT':
        case 'FULL':
            return anonymous
                ? formatAnonGender(gender)
                : [
                    formatGender(gender),
                    patient.firstname && formatPatientFirstname(patient.firstname),
                    patient.lastname && formatPatientLastname(patient.lastname),
                    kind === 'FULL' && patient.birthname
                        ? "(".concat(gender === 'FEMALE' ? 'née' : 'né', " ").concat(formatPatientLastname(patient.birthname), ")")
                        : null,
                ]
                    .filter(Boolean)
                    .join(' ') || 'Patient';
        case 'SHORT':
            return anonymous
                ? [formatAnonGender(gender), patient.birthdate && "(".concat((0, exports.formatAge)(patient.birthdate), ")")].filter(Boolean).join(' ')
                : [
                    patient.lastname && formatPatientLastname(patient.lastname),
                    patient.firstname && formatPatientFirstname(patient.firstname),
                ]
                    .filter(Boolean)
                    .join(' ') || 'Patient';
    }
    (0, __1.assertUnreachable)(kind);
}
var formatPassenger = function (_a) {
    var timeReference = _a.timeReference, departureTime = _a.departureTime, arrivalTime = _a.arrivalTime, timezone = _a.timezone, direction = _a.direction;
    if (timeReference === 'UNKNOWN' && direction === 'OUTBOUND' && departureTime) {
        return "".concat(formatTime(departureTime, false, timezone));
    }
    if (timeReference === 'ARRIVAL' && departureTime && arrivalTime) {
        return "Arriv\u00E9e \u00E0 ".concat(formatTime(arrivalTime, true, timezone));
    }
    if (timeReference === 'DEPARTURE' && departureTime && arrivalTime) {
        return "D\u00E9part \u00E0 ".concat(formatTime(departureTime, true, timezone));
    }
    return 'Heure inconnue';
};
exports.formatPassenger = formatPassenger;
var formatFleetVehicleType = function (type) {
    switch (type) {
        case 'AMBULANCE':
            return 'Ambulance';
        case 'VSL':
            return 'VSL';
        case 'TAXI':
            return 'Taxi';
        case 'BARIATRIC':
            return 'Bariatrique';
        case 'TPMR':
            return 'TPMR';
        case 'MEDICAL':
            return 'Ambulance médicalisée';
        case 'PARAMEDICAL':
            return 'Ambulance paramédicalisée';
    }
    (0, __1.assertUnreachable)(type);
};
exports.formatFleetVehicleType = formatFleetVehicleType;
//# sourceMappingURL=index.js.map